import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AddressDTO, AddressType, CompanyDTO, OfficeDTO } from '@iota/iota-management-portal-v4-client';
import { IotaModalOptions, IotaModalSize, MAT_DIALOG_DATA, MatDialogRef, ModalService } from '@iota/iota-ui-components';
import { Store } from '@ngrx/store';
import { CreateOffice } from 'src/app/store/actions/office.actions';
import { lastCreatedOfficeId, officeActionLoading } from 'src/app/store/reducer/office.reducer';
import { DefaultAddress } from '../../constants-and-enums/default-objects';
import { DialogUpsertResult } from '../../constants-and-enums/dialog-result-types';
import { getValueFromStore, waitForBooleanValue } from '../../utils';
import { AddressComponent } from '../../components/address/address.component';

@Component({
    standalone: false,
    selector: 'app-dialog-create-office',
    templateUrl: './dialog-create-office.component.html',
    styleUrls: ['./dialog-create-office.component.scss']
})
export class DialogCreateOfficeComponent implements OnInit {
    public modalOptions: Partial<IotaModalOptions> = {
        size: IotaModalSize.SIZE_7XL,
        showToggleFullScreenButton: true
    };
    @ViewChild(AddressComponent) addressComponent: AddressComponent;

    constructor(
        public dialogRef: MatDialogRef<DialogCreateOfficeComponent>,
        private dialog: ModalService,
        @Inject(MAT_DIALOG_DATA) public data: { company: CompanyDTO; office: OfficeDTO },
        private store: Store
    ) {}

    ngOnInit(): void {
        this.addAddress();
    }

    createLoading = false;

    get isFormValid() {
        return this.addressComponent && this.addressComponent.addressForm.valid;
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    async onSaveClick() {
        const addressFormValue = this.addressComponent.addressForm.value;
        addressFormValue.addressType = AddressType.MAIN_ADDRESS;
        this.data.office.addresses = [addressFormValue];
        this.data.office.companyId = this.data.company.companyId;

        this.store.dispatch(CreateOffice({ office: this.data.office }));

        this.createLoading = true;

        await waitForBooleanValue(this.store, officeActionLoading, false);
        const id = await getValueFromStore(this.store, lastCreatedOfficeId);

        const result: DialogUpsertResult = { id };
        this.dialogRef.close(result);
    }

    addAddress() {
        const address: AddressDTO = DefaultAddress();
        this.data.office.addresses = [address].concat(this.data.office.addresses);
    }

    deleteAddress(address: AddressDTO) {
        this.data.office.addresses = this.data.office.addresses.filter((a) => a !== address);
    }
}
